// extracted by mini-css-extract-plugin
module.exports = {"logoPortal":"styles_logoPortal__1opq4"};